import router from '@/router'
import TagManagementPage from './views/TagManagementPage.vue'

router.addRoute({
  path: '/tags',
  name: 'TagManagementPage',
  component: TagManagementPage,
  meta: {
    layout: 'dashboard'
  }
})
